<template>
  <div>
    <a-card ref="recharge">
      <div style="margin-bottom: 30px;">
        <div style="font-size:18px;font-weight:700;color:black;margin-bottom:20px;">充值金额</div>
        <a-button style="margin:20px 20px 60px 0px;" v-for="(list, index) in dataList" @click="changeTab(index)" :key="index" size="large">{{
          list
        }}</a-button>
        <a-form-item v-if="visible9" :labelCol="labelCol" :wrapperCol="wrapperCol" style="font-size:18px;font-weight:700" label="其他金额">
          <a-input-number style="width: 20%" :step="1" :min="0" :precision="0" v-model="totalAmount" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="应付金额" style="font-size:18px;font-weight:700">
          <a v-show="totalAmount>=0">{{ totalAmount }}元</a>
        </a-form-item>
      </div>
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="选择支付方式" style="font-size:18px;font-weight:700;">
        <a-radio-group name="radioGroup" :default-value="1" v-model="payType" :disabled="rechargeNum == 1">
          <a-radio-button :value="2" style="margin-right:30px" ><a-icon type="alipay-square" theme="filled" style="padding-right:7px;font-size:18px;color:#07aaff" />支付宝</a-radio-button>
          <a-radio-button :value="1"> <a-icon type="money-collect" style="padding-right:7px;font-size:18px;color:#00c800" />线下支付 </a-radio-button>
        </a-radio-group>
      </a-form-item>
      <a-form-item v-if="payType == 2" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <div style="width: 100%; margin-left: 25px">
          <a-icon type="exclamation-circle" style="margin: 0 5px; color: #ffd700" />
          请在提交订单后30分钟内完成支付，否则订单会自动取消
        </div>
      </a-form-item>
      <a-form-item v-if="payType == 1" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <div style="margin-left: 25px">
          <div>开户名称：江苏锁安科技有限公司</div>
          <div>开户银行：招商银行南京分行雨花支行</div>
          <div>银行账号：125908208810601</div>
        </div>
      </a-form-item>
      <a-model v-if="current == 2">
        <div style="width: 100%; text-align: center; margin-top: 40px; font-size: 24px">
          <p>
            <span>充值交易号: </span>
            <span>{{ orderNumber }}</span>
          </p>
          <p>充值完成！</p>
          <p>请联系财务人员确认是否充值成功</p>
        </div>
      </a-model>
      <div style="display:flex;justify-content:center;width:100%;" >
        <a-button v-if="current < steps.length - 1" type="primary" @click="next" style="margin: 0 25px">
          确定
        </a-button>
        <a-button v-if="current == steps.length - 1" type="primary" @click="next" style="margin: 0 25px">
          确定
        </a-button>
        <a-button type="primary" @click="reset" style="margin: 0 25px">
          {{ current==2 ? '再次充值':'重选' }}
        </a-button>
      </div>
      <div v-if="current == 0" style="text-align:center;width:50%"> 一旦充值无法提现，如果要提现请联系锁安工作人员</div>
    </a-card>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { ACCESS_TOKEN } from '@/store/mutation-types'
export default {
  name: 'UserMenu',
  components: {
  },
  computed: {
    ...mapGetters(['nickname', 'avatar'])
  },
  data () {
    return {
      headers: {
        token: Vue.ls.get(ACCESS_TOKEN)
      },
      customerOrder: '',
      // *************************************?
      assignStatus: '',
      customerName: '',
      customerMobile: '',
      provinceId: undefined,
      cityId: undefined,
      areaId: undefined,
      OrderStatus: '',
      detailedAddress: '',
      installType: undefined,
      orderType: undefined,
      updateBy: '', // 处理人
      updateTime: null, // 处理时间
      deleteBy: '', // 移除人
      deleteTime: null, // 移除时间
      deleteReason: '', // 移除原因
      createTime: '',
      autoorder: false,
      havework: false,
      provinceMap: [],
      cityMap: [],
      areaArr: [],
      remarkChanges: '',
      selectedRowKeys: [],
      List: [],
      dataList: ['200', '400', '600', '800', '1000', '1500', '2000', '3000'],
      // 标识，初始化默认选中第一项
      clicked: 0,
      current: 1,
      count: '',
      // 支付流程
      steps: [
        {
          title: '填写金额',
          content: 'form-content'
        },
        {
          title: '确认并支付',
          content: 'Second-content'
        },
        {
          title: '完成',
          content: 'Last-content'
        }
      ],
      confirmDirty: false,
      autoCompleteResult: [],
      nterpriseRechargeId: '',
      // 订单号
      orderNumber: '',
      // 支付方式
      payType: '',
      // 充值金额
      totalAmount: 0,
      // 充值列表
      billingInformation: '',
      // 钱包余额
      totalBalance: '',
      // 企业名称
      enterpriseName: '',
      // 是否为 客服部
      deptId: '',
      // 是否为企业账号
      userType: '',
      finance: '',
      datalist12: '',
      confirmLoading: false,
      queryParam: {},

      // 值订单账号
      orderNo: '', // 订单号
      // rechargeId:'',
      // 状态
      status: 0,
      // 支付状态
      payStatus: '',
      // 后台返回的html
      html1: '',
      // 充值时间
      rechargeTime: '',
      rechargeNum: '',
      technicalIdArr: [],
      restaurantOperTypeMap: [],
      restaurantOperType: [],
      restaurantOperTypeMap2: [],
      time: null,
      handleRemoveRecord: '',
      removeStateNum: '',
      beOnDutyIndex: '',
      disGoBackAdd: false,
      createStartTime: null,
      createEndTime: null,
      updateStartTime: null,
      updateEndTime: null, // 处理结束时间
      deleteStartTime: null,
      deleteEndTime: null,
      visible9: false
    }
  },
  created () {
    this.$axios({
      method: 'get',
      url: '/api/finance/pay/checkIdentification ',
      headers: {
        token: Vue.ls.get(ACCESS_TOKEN),
        'Content-Type': 'application/json;charset=UTF-8'
      }
    }).then(res => {
      this.OrderStatus = res.data.data
    })
  },
  methods: {
    // 重置
    reset () {
      this.current = 1
      this.totalAmount = 0.0
      this.payType = ''
      this.visible9 = false
    },
    queryList () {
      this.dataListReq(this.status)
    },
    changeTabs (e) {
      this.queryKong()
      this.status = e - 1
      this.dataListReq(this.status)
    },
    onSelectChange (selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    removeState (e) {
      this.removeStateNum = e
    },
    handleAdd14 (record) {
      this.$axios({
        method: 'get',
        url: '/api/order/customer/recoverOrder?id=' + record.id,
        headers: {
          token: Vue.ls.get(ACCESS_TOKEN),
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then(res => {
        if (res.data.code == 0) {
          this.$message.success('恢复成功')
          this.dataListReq(this.status)
        }
      })
    },

    handleSubmit10 () {
      this.visible11 = false
    },
    CustomerOrders () {
      this.visible12 = true
      this.status = 0
      this.queryKong()
      ;(this.selectedRowKeys = []),
      this.$axios({
        method: 'get',
        url: '/api/order/customer/selectOrderList',
        params: {
          enterpriseId: '',
          customerName: '',
          customerMobile: '',
          provinceId: '',
          cityId: '',
          areaId: '',
          detailedAddress: '',
          installType: '',
          orderType: '',
          createTime: '',
          status: this.status
        },
        headers: {
          token: Vue.ls.get(ACCESS_TOKEN),
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then(res => {
        this.data12 = res.data.rows
        this.datalist12 = res.data.rows.length
      })
    },
    installChange (e) {
      this.installType = e
      this.List = []
      this.orderType = undefined
      this.$axios({
        method: 'get',
        url: '/api/basicdata/orderType/getList/' + e,
        headers: {
          token: Vue.ls.get(ACCESS_TOKEN),
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then(res => {
        if (res.data.code == 0) {
          this.List = res.data.rows
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    orderTypeChange (e) {
      this.orderType = e
    },
    openNewWindow (lis) {
      this.$nextTick(() => {
        const divForm = document.getElementsByTagName('divform')
        if (divForm.length) {
          document.body.removeChild(divForm[0])
        }
        const div = document.createElement('divform')
        div.innerHTML = lis // data就是接口返回的form 表单字符串
        document.body.appendChild(div)
        document.forms[0].setAttribute('target', '_blank') // 新开窗口跳转
        document.forms[0].submit()
      })
    },
    handleSubmit12 () {
      this.visible12 = false
    },
    next (value) {
      let num = 0
      this.rechargeNum = 0
      if (this.totalAmount != 0) {
        if (this.current == 0) {
          this.current++
          num = 1
        } else if (this.current == 1) {
          num = 2
        }
      } else {
        this.$message.error('请选择或输入金额')
      }
      if (num == 2) {
        if (this.payType != '') {
          var enterpriseId = this.$store.getters.enterpriseId
          this.$axios({
            method: 'post',
            url: '/api/finance/pay/insert',
            data: {
              enterpriseId: enterpriseId,
              totalAmount: this.totalAmount,
              payType: this.payType
            },
            headers: {
              token: Vue.ls.get(ACCESS_TOKEN),
              'Content-Type': 'application/json;charset=UTF-8'
            }
          }).then(res => {
            this.orderNumber = res.data.data
            if (this.payType == 2) {
              this.$axios({
                method: 'get',
                url: '/api/finance/pay/pay',
                params: {
                  rechargeId: res.data.data,
                  totalAmount: this.totalAmount
                },
                headers: {
                  token: Vue.ls.get(ACCESS_TOKEN),
                  'Content-Type': 'application/json;charset=UTF-8'
                }
              }).then(res => {
                this.html1 = res.data.data
                this.openNewWindow(this.html1)
                const that = this
                this.$confirm({
                  title: '支付',
                  content: '请在新打开的页面进行支付',
                  okType: 'danger',
                  onOk () {
                    that.current++
                  },
                  onCancel () {
                    console.log('Cancel')
                  }
                })
                this.$axios({
                  method: 'get',
                  url: '/api/finance/pay/delayed',
                  params: {
                    tradeNo: this.orderNumber
                  },
                  headers: {
                    token: Vue.ls.get(ACCESS_TOKEN),
                    'Content-Type': 'application/json;charset=UTF-8'
                  }
                })
              })
            } else {
              this.current++
            }
          })
        } else {
          this.$message.error('请选择支付方式！')
        }
      }
      // }
      if (this.current == 2) {
        this.visible6 = false
      }
    },
    // 选择金额
    changeTab (index) {
      this.clicked = index
      if (this.clicked == 0) {
        this.visible9 = false
        this.totalAmount = 200.0
      } else if (this.clicked == 1) {
        this.visible9 = false
        this.totalAmount = 400.0
      } else if (this.clicked == 2) {
        this.visible9 = false
        this.totalAmount = 600.0
      } else if (this.clicked == 3) {
        this.visible9 = false
        this.totalAmount = 800.0
      } else if (this.clicked == 4) {
        this.visible9 = false
        this.totalAmount = 1000.0
      } else if (this.clicked == 5) {
        this.visible9 = false
        this.totalAmount = 1500.0
      } else if (this.clicked == 6) {
        this.visible9 = false
        this.totalAmount = 2000.0
      } else if (this.clicked == 7) {
        this.visible9 = false
        this.totalAmount = 3000.0
      } else if (this.clicked == 8) {
        this.visible9 = true
        this.totalAmount = 0.0
      } else {
        this.visible9 = false
      }
    },
    // 支付
    handleEdit2 (record) {
      this.rechargeNum = 1
      this.totalAmount = record.rechargeMoney
      this.enterpriseName = this.enterpriseName
      this.orderNumber = record.orderNo
      this.orderNo = record.orderNo
      this.current = 1
      this.payType = 2
      this.$axios({
        method: 'get',
        url: '/api/finance/pay/pay',
        params: {
          rechargeId: this.orderNo,
          totalAmount: this.totalAmount
        },
        headers: {
          token: Vue.ls.get(ACCESS_TOKEN),
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then(res => {
        this.html1 = res.data.data
        this.openNewWindow(this.html1)
        const that = this
        this.$confirm({
          title: '支付',
          content: '请在新打开的页面进行支付',
          okType: 'danger',
          onOk () {
            that.current++
          },
          onCancel () {
            console.log('Cancel')
          }
        })
        this.$axios({
          method: 'get',
          url: '/api/finance/pay/delayed',
          params: {
            tradeNo: this.orderNumber
          },
          headers: {
            token: Vue.ls.get(ACCESS_TOKEN),
            'Content-Type': 'application/json;charset=UTF-8'
          }
        })
      })
    }
  },
  watch: {
    $route (to, from) {
      Object.assign(this.$data, this.$options.data())
    }
  }

}
</script>
<style scoped>

</style>
